import React from 'react';
import EmptyState from '../components/EmptyState';

const DevDocumentsKnowledgePage = () => {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">
          Documents & Knowledge
        </h1>
        <p className="text-sm text-slate-500">Document bank and knowledge base</p>
      </header>
      <EmptyState message="Documents & Knowledge page - Coming soon" />
    </div>
  );
};

export default DevDocumentsKnowledgePage;
